import React, { useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { CircularProgress } from "@material-ui/core";

import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { getCommissionHistoryAsync } from "../../redux";

const CommissionHistoryDetail = () => {
  const { id } = useParams();

  const { isLoading, selectedData } = useSelector(
    (state) => state.commissionHistory,
    shallowEqual
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCommissionHistoryAsync(id));
  }, [id]);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (!selectedData) {
    return (
      <div className="form-group m-0 d-flex align-items-center text-white">
        <span className="pl-2">Transaction detail not found</span>
      </div>
    );
  }

  return (
    <Card>
      <CardHeader
        title={
          <>
            <div className="form-group m-0 d-flex align-items-center ">
              <Link
                className="btn btn-link px-0 text-white"
                to="/commission-history"
              >
                <SVG
                  className="h-50 align-self-center text-white right-caret-btn"
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Arrow-left.svg"
                  )}
                />
                Back
              </Link>
              <span className="pl-2">Commission History Details</span>
            </div>
          </>
        }
      >
        <CardHeaderToolbar>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <form
              autoComplete="off"
              className="subheader_filter"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="form-row"></div>
            </form>
          </div>
        </CardHeaderToolbar>
      </CardHeader>
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white">
            <h4 className="mb-0">Commission History Details</h4>
          </div>
          <div className="card-body text-light">
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                User Name:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.userName || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Commission Type:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.commission_type || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Total Amount:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.amount + selectedData?.deduction_amount || 0}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Commission Rate:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.percentage || "-"}%
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Commission Earned:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.deduction_amount || "-"}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Bet Id:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                <a
                  style={{ color: "#fff" }}
                  href={`/bet-management/bet-result-details/${selectedData.bet_id}`}
                  target="_blank"
                >
                  {selectedData?.bet_id}
                </a>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4 font-weight-bold text-white">
                Created At:
              </div>
              <div className="col-md-8" style={{ color: "#f8f9fa" }}>
                {selectedData?.createdAt
                  ? moment(selectedData.createdAt).format(
                      "dddd, MMMM Do YYYY, h:mm:ss a"
                    )
                  : "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CommissionHistoryDetail;
